/**
 * Processing terms (mission 7 WP07 T039; FR-006, FR-007, FR-023; TX.3;
 * contracts/terms-api.md). The text is `PROCESSING_TERMS` in
 * `lib/mandatory-copy.ts`; Accept posts its `version`, and the API refuses any
 * version but the configured one, so the version accepted is the one rendered.
 */
import { api } from '../api'

/** GET /v1/processing-terms, and the POST answer. */
export interface ProcessingTermsStatus {
  current_version: string
  /** The tenant accepted `current_version`. */
  accepted: boolean
  /** The tenant's most recent acceptance of any version, or null. */
  accepted_version: string | null
  accepted_at: string | null
}

export async function getProcessingTerms(): Promise<ProcessingTermsStatus> {
  return api<ProcessingTermsStatus>('/processing-terms')
}

/** POST /v1/processing-terms/accept (RequireOwner); idempotent. */
export async function acceptProcessingTerms(version: string): Promise<ProcessingTermsStatus> {
  return api<ProcessingTermsStatus>('/processing-terms/accept', { method: 'POST', body: JSON.stringify({ version }) })
}
